import React, { useState } from 'react';
import { MenuItem, MenuList, Stack, Typography, Button } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { observer } from 'mobx-react-lite';
import useLocales, { LANGUAGES, getLanguage } from '~/hooks/use_locales';
import useMst from '~/hooks/use_mst';
import { MenuPopoverStyled } from './styled';

function LanguagePopover() {
  const { auth } = useMst();
  const { changeLanguage, i18n } = useLocales();
  // Use auth.user?.locale if available, otherwise fall back to i18n.language
  const locale = auth.user?.locale || i18n.language;
  const language = getLanguage(locale);
  const [open, setOpen] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLanguage = async (value: string) => {
    changeLanguage(value);

    // Save the language preference to the user model if user is logged in
    if (auth.user) {
      auth.user.update({ locale: value });
    }

    handleClose();
  };

  return (
    <>
      <Button onClick={handleOpen} variant="text" size="small" sx={{ minWidth: 'auto', px: 1 }} startIcon={<LanguageIcon fontSize="small" />}>
        {language?.baseCode?.toUpperCase() || 'EN'}
      </Button>

      <MenuPopoverStyled open={Boolean(open)} anchorEl={open} onClose={handleClose}>
        <MenuList disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
          {LANGUAGES.map(({ value, label, baseCode }) => (
            <MenuItem key={value} selected={locale === value} onClick={() => handleLanguage(value)}>
              <Stack
                direction="row"
                spacing={1}
                sx={{
                  alignItems: 'center'
                }}
              >
                <Typography variant="body2">{baseCode.toUpperCase()}</Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary'
                  }}
                >
                  {label}
                </Typography>
              </Stack>
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopoverStyled>
    </>
  );
}

export default observer(LanguagePopover);
